import PropTypes from "prop-types"
import classnames from "classnames"
import { colorWithOpacity } from "helpers/colors"

function Row({ data, column: { color, type, noData, isUnmodeled }, index, selector }) {
  let loading = !data[index] && !noData && !isUnmodeled
  let value = !loading && !noData && !isUnmodeled && selector && selector(data[index], type)
  if (value === "Loading...") {
    loading = true
    value = ""
  }

  const style = loading
    ? { background: `linear-gradient(90deg, ${colorWithOpacity(color, 0.1)}, ${colorWithOpacity(color, 0.3)})` }
    : { backgroundColor: colorWithOpacity(color, 0.1) }

  return <div className={classnames({ loading })} style={style}>
    {value}
  </div>
}

Row.propTypes = {
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    type: PropTypes.string,
    label: PropTypes.string.isRequired,
    noData: PropTypes.bool,
    isUnmodeled: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  selector: PropTypes.func,
  data: PropTypes.array.isRequired,
}

export default Row
